import * as R from "ramda";
import { parseCategorisations } from "./parseCategorisations.mjs";
const getArtefactCategories = ({ artefactId, data = {} }) => {
  const categorisations = parseCategorisations({ data });
  const categorySchemes = R.indexBy(
    R.pipe(
      R.props(["agencyID", "id", "version"]),
      ([agency, code, version]) => `${agency}:${code}(${version})`
    )
  )(R.propOr([], "categorySchemes", data));
  const getHierarchicalCategories = ({ categories, ids }) => {
    if (R.isEmpty(categories) || R.isEmpty(ids)) {
      return [];
    }
    const id = R.head(ids);
    const category = R.find(R.propEq(id, "id"), categories);
    if (R.isNil(category)) {
      return [];
    }
    const children = getHierarchicalCategories({
      categories: R.propOr([], "categories", category),
      ids: R.tail(ids)
    });
    return R.prepend({ id, name: R.prop("name")(category) }, children);
  };
  return R.reduce(
    (acc, { schemeId, path }) => {
      const scheme = R.prop(schemeId, categorySchemes);
      if (R.isNil(scheme)) {
        return acc;
      }
      const categories = getHierarchicalCategories({
        categories: scheme.categories,
        ids: R.split(".", path)
      });
      if (R.isEmpty(categories)) {
        return acc;
      }
      const name = R.prop("name")(scheme);
      return [...acc, R.prepend({ id: scheme.id, name }, categories)];
    },
    [],
    R.propOr([], artefactId, categorisations)
  );
};
export {
  getArtefactCategories
};
